import appConstants from "./app.constants";

const wFActionConstants = {
  actionProgress: [{
    actionCodeID: appConstants.taskAction.created,
    stepsDone: 0
  },{
    actionCodeID: appConstants.taskAction.rejected,
    stepsDone: 0
  },{
    actionCodeID: appConstants.taskAction.done,
    stepsDone: 1
  },{
    actionCodeID: appConstants.taskAction.doneWithException,
    stepsDone: 1
  },{
    actionCodeID: appConstants.taskAction.reviewed,
    stepsDone: 2
  },{
    actionCodeID: appConstants.taskAction.approved,
    stepsDone: 3
  },{
    actionCodeID: appConstants.taskAction.complied,
    stepsDone: 4
  },{
    actionCodeID: appConstants.taskAction.compliedWithException,
    stepsDone: 4
  },{
    actionCodeID: appConstants.taskAction.canceled,
    stepsDone: 0
  },{
    actionCodeID: appConstants.taskAction.rescheduled,
    stepsDone: 0
  },{
    actionCodeID: appConstants.taskAction.reassigned,
    stepsDone: 0
  }],

  endState: [appConstants.taskAction.complied, appConstants.taskAction.compliedWithException, appConstants.taskAction.canceled],
  negativeActions: [
    appConstants.taskAction.doneWithException,
    appConstants.taskAction.canceled,
    appConstants.taskAction.rescheduled
  ],

  // pastTense: {
  //   10901: 'Created',
  //   10902: 'Submitted For Review',
  //   10903: 'Approved',
  //   10904: 'Change Requested',
  //   10905: 'Cancelled',
  //   10906: 'Done With Exceptions',
  //   10907: 'Reviewed',
  //   10908: 'Complied',
  //   10909: 'Partially Complied',//'Complied with Exceptions',
  //   10910: 'Re-scheduled',
  // },

  // presentTense: {
  //   10902: 'Mark As Done',
  //   10903: 'Mark As Approved',
  //   10904: 'Request Change',
  //   10905: 'Cancel Task',
  //   10906: 'Mark As Done With Exceptions',
  //   10907: 'Review Task',
  //   10908: 'Mark As Complied',
  //   10909: 'Mark As Partially Complied',//'Mark As Complied With Exceptions',
  //   10910: 'Re-schedule Task',
  // },

  badgeColor: {
    10901: 'gray',
    10902: 'light-success',
    10903: 'light-success',
    10904: 'light-danger',
    10905: 'danger',
    10906: 'light-success',
    10907: 'light-success',
    10908: 'success',
    10909: 'warning',
    10910: 'danger',
    10911: 'gray'
  }
}

export default wFActionConstants

// [{
//   db: 10901,
//   ui: [{btn: 'Done', next: 10902, log: 'Done'}, {btn:'Done with exceptions', next: 10903, log: 'Done with exceptions'}],
// },{
//   db: 10902,
//   ui: [{btn: 'Verified', next: 10903, log: 'Verified'}, {btn: 'Request change', next: 10903, log: 'Requested change'}]
// },{
//   db: 10903,
//   ui: ['Verified', 'Request change']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },{
//   db: 10901,
//   ui: ['Done', 'Done with exceptions']
// },]